/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Purchase_DateInputs */

const vi_tea_purchase_purchase_date = /** @type {(inputs: Tea_Purchase_Purchase_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày cân`)
};

/**

* @param {Tea_Purchase_Purchase_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_purchase_date = /** @type {((inputs?: Tea_Purchase_Purchase_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Purchase_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_purchase_date(inputs)
});